import React from 'react';
import { Link } from 'gatsby';

import NavigationMenu from '../NavigationMenu';
import Wrapper from '../../ui/Wrappers';
import Basic from './styles';

import Logo from '-!svg-react-loader!../../ui/svgs/kidsandus-logo.svg';

const SimpleHeader = () => (
  <Basic>
    <Wrapper size="mainwrapper">
      <Link
        to="/"
        aria-label={`This image is the Kids and Us logo. Clicking on this image will redirect you to the home`}>
        <img src="images/kidsandus-logo.png"></img>
        <Logo className="svg" />
      </Link>
    </Wrapper>
  </Basic>
);

const Header = ({
  children,
  siteTitle,
  lang,
  pageCta,
  domain,
  country,
  pageHref,
  isFranchise,
  translations
}) => (
  <>
    {children}
    <NavigationMenu
      mainName={`main-${country}`}
      secondName={`secondary-${country}`}
      langcode={lang}
      pageCta={pageCta}
      domain={domain}
      pageHref={pageHref}
      isFranchise={isFranchise}
      translations={translations}
    />
  </>
);

Header.defaultProps = {
  siteTitle: ''
};

export { SimpleHeader };

export default Header;
